import React from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Icons from 'consts/icons';
import Tooltip from '@material-ui/core/Tooltip';
import PopupLoader from 'components/common/PopupLoader';
import { addAlert } from 'store/actions/alert/alerts';
import { addApprovedArea } from 'store/actions/map/approvedAreas';
import { authPostRequest } from 'helpers/apiRequests';
import { Grid } from '@material-ui/core';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import Map from 'components/common/components/drawMap/Map';
import { userStyles } from 'consts/styles/User';
import { formStyles } from 'consts/styles/Form';
import ApprovedAreaForm from 'components/approvedAreas/manageApprovedAreas/ApprovedAreaForm';

import {
  borderValues,
  generatePolygons,
  validateCheck,
  validateData,
} from '../utils/main';

const AddArea = props => {
  const { getToPreviousScreen } = props;

  const dispatch = useDispatch();

  const strings = useSelector(state => state.language);
  const closeSubtitles = useSelector(state => state.language).close_;

  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const [geojson, setGeojson] = React.useState(null);
  const rerenderedGeojson = React.useRef(false);
  const [values, setValues] = React.useState({
    othername: '',
    description: '',
    elevation_type: 'srtm',
    visibility: 'private',
    type: 'DRA-I',
    category: 'corridor',
    agl_min: 40,
    agl_max: 60,
    amsl_max: 0,
    amsl_min: 0,
    width: 10,
    contact: '',
    active: true,
    name: '',
  });
  const [errors, setErrors] = React.useState({});

  const classesUser = userStyles();
  const formClasses = formStyles();

  const save = async () => {
    const data = { ...values };
    data.agl_min = parseInt(data.agl_min);
    data.agl_max = parseInt(data.agl_max);
    data.geojson = geojson;
    data.name = `${values.type} ${
      UserSessionDataHandler.getUserDataObject().organization
    } ${values.othername}`;
    const dataErrors = validateData(data);
    if (dataErrors) {
      setErrors(dataErrors);
      return;
    }
    setSeeableLoader(true);
    const result = await authPostRequest('areas', data);
    if (result?.status === 201) {
      dispatch(
        addAlert({
          title: strings.alerts.addDataSuccess.title_,
          desc: strings.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      dispatch(addApprovedArea(result.data));
      setSeeableLoader(false);
    } else
      dispatch(
        addAlert({
          title: strings.alerts[result?.data?.code].title_,
          desc: strings.alerts[result?.data?.code].desc_,
          type: 'error',
        })
      );
    handleCloseIcon();
    setSeeableLoader(false);
  };

  const handleCloseIcon = () => {
    getToPreviousScreen();
  };

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;
    const ifCheckIsTrue = validateCheck(name, value);

    setValues({
      ...values,
      [name]: value,
    });

    setErrors({ ...errors, [name]: !ifCheckIsTrue });
  };

  React.useEffect(() => {
    if (rerenderedGeojson.current) {
      rerenderedGeojson.current = false;
      return;
    }
    handleGeojsonChange();
  }, [geojson, values.width, values.agl_max, values.agl_min]);

  const handleGeojsonChange = () => {
    if (!geojson || !values.width) return;
    const tmpGeojson = getLineFeatureFromGeojson();
    const generatedGeojson = generatePolygons(tmpGeojson, values.width, {
      min: values.agl_min,
      max: values.agl_max,
    });
    rerenderedGeojson.current = true;
    setGeojson(generatedGeojson);
  };

  const getLineFeatureFromGeojson = () =>
    geojson.type === 'FeatureCollection'
      ? geojson.features.find(area => area.geometry.type === 'LineString')
          ?.geometry
      : geojson;

  return ReactDOM.createPortal(
    <div
      className={`${classesUser.User}__add-component`}
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100vw - 30px)',
        height: '80vh',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRadius: 8,
        padding: 15,
        backgroundColor: 'rgba(11, 17, 32, 0.95)',
      }}
    >
      {seeableLoader && <PopupLoader />}
      <Grid
        item
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between `}
      >
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
        >
          {strings.areas.add.header_}
        </Typography>
        <Tooltip title={closeSubtitles} placement="bottom">
          <div
            className={`${classesUser.User}__settings__close`}
            onClick={() => handleCloseIcon()}
            onKeyPress={() => handleCloseIcon()}
            role="button"
            tabIndex={0}
          >
            <div className={`${classesUser.User}__settings__close__container`}>
              <Icons.Actions.Close />
            </div>
          </div>
        </Tooltip>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid
            item
            xs={7}
            className={`${formClasses.Form}__overflow-component ${formClasses.Form}__overflow-component--with-map`}
          >
            <Map
              setGeojson={setGeojson}
              geojson={geojson}
              drawTypes={['line']}
              setErrors={setErrors}
              errors={errors}
            />
          </Grid>
          <Grid
            item
            xs={5}
            className={`${formClasses.Form}__overflow-component`}
          >
            <ApprovedAreaForm
              save={save}
              values={values}
              errors={errors}
              handleChange={handleChange}
              borderValues={borderValues}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>,
    document.body
  );
};

AddArea.propTypes = {
  getToPreviousScreen: PropTypes.func.isRequired,
};

export default AddArea;
